import Ripple from 'vue-ripple-directive'
import CopyToClipboard from 'vue-copy-to-clipboard'
import QrcodeVue from 'qrcode.vue'
import moment from '@/libs/moment'
import CustomerWalletApis from '@/modules/crypto/services/apis/customer-wallet'

const GetDescription = () => import(`@/views/${process.env.VUE_APP_THEME_NAME}/components/getDescription.vue`)

const customerWallet = new CustomerWalletApis()

export default {
  components: {
    CopyToClipboard,
    GetDescription,
    QrcodeVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      show: false,
      coin: '',
      network: '',
      coinInfo: {},
      walletAddress: '',
      pop1: false,
      lastDeposits: [],
      cards: [],
      currentpageTransactions: 1,
      totalTransactions: 0,
      perPageTransactions: 10,
      makeWalletLoading: false,
      size: 150,
      items: [],
      pop2: false,
      selectedTransactionId: '',
      selectedTransactionNetwork: '',
      transactionIdModal: false,
      qrModal: false,
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$t('coin'),
          key: 'currency',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('Network'),
          key: 'network',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('amount'),
          key: 'amount',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('date'),
          key: 'created_at',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('status'),
          key: 'status',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('transaction_id'),
          key: 'transaction_id',
          tdClass: 'nameOfTheClass',
        },
      ]
    },
    isDarkTheme() {
      return this.$store.state.appConfig.layout.skin === 'dark'
    },

  },

  watch: {
    pop1(val) {
      if (val) {
        setTimeout(() => {
          this.pop1 = false
        }, 2500)
      }
    },
    currentpageTransactions(val) {
      if (val) {
        this.getlastDeposits()
      }
    },
    network(val) {
      this.show = true
      customerWallet.getWalletAddress({ currency: this.$route.params.coin_symbol, network: val }).then(async res => {
        const walletAddress = res.data.results?.address ? res.data.results?.address : res.data.results[0]?.network?.wallets[0]?.address
        if (walletAddress) {
          this.walletAddress = walletAddress
          this.show = false
        }
      }).catch(() => {
        this.walletAddress = ''
      }).finally(() => {
        this.show = false
      })
    },
  },

  async mounted() {
    if (this.$route.params.coin_name && this.$route.params.coin_symbol) {
      customerWallet.getCoin(this.$route.params.coin_symbol).then(coin => {
        this.coinInfo = coin.data.results
        this.network = coin.data.results.currency_network[0].network.nick_name
        this.coin = coin.data.results.token
      })
    } else {
      this.$router.push(`/${this.$i18n.locale}/crypto-wallets`)
    }
    this.getlastDeposits()
  },

  methods: {
    copyAddress() {
      this.pop1 = true
    },

    copyTransaction() {
      this.pop2 = true
    },

    getlastDeposits() {
      this.show = true
      customerWallet.lastDeposits({
        current_page: this.currentpageTransactions,
        per_page: this.perPageTransactions,
      })
        .then(res => {
          this.totalTransactions = res.data.results.paginate.total
          this.currentpageTransactions = res.data.results.paginate.current_page
          this.perPageTransactions = res.data.results.paginate.per_page
          this.items = res.data.results.data
        }).finally(() => {
          this.show = false
        })
    },

    getFormattedDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    triggerTransactionModal({ transaction_id, network_name }) {
      this.transactionIdModal = true
      // eslint-disable-next-line camelcase
      this.selectedTransactionId = transaction_id
      // eslint-disable-next-line camelcase
      this.selectedTransactionNetwork = network_name
    },
    openTransaction() {
      if (this.selectedTransactionNetwork === 'TRC20' && this.selectedTransactionId) {
        window.open(`https://tronscan.org/#/transaction/${this.selectedTransactionId}`, '_blank')
      } else if (this.selectedTransactionNetwork === 'BSC' && this.selectedTransactionId) {
        window.open(`https://bscscan.com/tx/${this.selectedTransactionId}`, '_blank')
      }
      this.transactionIdModal = false
    },
    openQrModal() {
      this.qrModal = true
    },
  },
}
